// La page d'entrée est passée à React (js/react/ecrans/Connexion.jsx).
//
// C'est le dernier écran migré, et il a été gardé pour la fin exprès : c'est le
// seul dont un défaut n'empêche pas de FAIRE quelque chose, mais d'ENTRER.
//
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import Connexion from "../react/ecrans/Connexion.jsx";

export const rendre = vueReact(Connexion);
